// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import { UserProvider } from "./UserContext";
import InstallNextScenes from "./components/InstallNextScenes";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <UserProvider>
    <Router>
      <App />
      <InstallNextScenes />
    </Router>
  </UserProvider>
);

// NextScenes PWA Foundation V1
// Registration is production-only so local development remains predictable.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((registration) => {
        console.info("NextScenes service worker registered:", registration.scope);
      })
      .catch((error) => {
        console.error("NextScenes service worker registration failed:", error);
      });
  });
}
